/**
 * Retire un élément de l'array
 */
export function arrayRemove(arr: any[], obj: any): void {
    let index = arr.indexOf(obj);
    if (index >= 0) {
        arr.splice(index, 1);
    }
}